import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { delay: { type: Number, default: 350 } }

    connect() {
        this.timeoutId = null
    }

    queue() {
        clearTimeout(this.timeoutId)
        this.timeoutId = setTimeout(() => this.submit(), this.delayValue)
    }

    submit() {
        const form = this.element.tagName === "FORM" ? this.element : this.element.closest("form")
        if (form) {
            // Use FormData to ensure proper submission
            const formData = new FormData(form)
            const url = new URL(form.action || window.location.href)

            // Build query string from form data
            const params = new URLSearchParams(formData)
            url.search = params.toString()

            // Use Turbo.visit for a proper Turbo-powered navigation
            Turbo.visit(url.toString(), { action: "replace" })
        }
    }

}